// @ts-nocheck
import { getDocumentList } from "@store/Framework/Services/QuoteService";
import { createHandlerChainRunner, Handler } from "@toolkit/Modules/client-framework/HandlerCreator";

type GetRfqDetailsDocumentsParameter = {
    orderNumber: string;
};
type Props = {
    apiParameter: GetRfqDetailsDocumentsParameter;
    apiResult: any;
};

type HandlerType = Handler<GetRfqDetailsDocumentsParameter, Props>;

export const PopulateApiParameter: HandlerType = props => {
    props.apiParameter = { ...props.parameter };
};

export const RequestDataFromApi: HandlerType = async props => {
    props.apiResult = await getDocumentList(props.apiParameter.orderNumber);
};

export const DispatchCompleteGetRfqDetailsDocuments: HandlerType = props => {
    const { dispatch, apiResult } = props;
    dispatch({
        type: "Store/Pages/RfqQuoteDetails/GetRfqDetailsDocuments",
        rfqDetailsDocuments: apiResult,
    });
};

export const chain = [PopulateApiParameter, RequestDataFromApi, DispatchCompleteGetRfqDetailsDocuments];

const getQuoteDetailsDocuments = createHandlerChainRunner(chain, "GetQuoteDetailsDocuments");
export default getQuoteDetailsDocuments;
